import { Command } from "./command.js";
export class LRangeCommand extends Command {
    constructor(cmd, opts) {
        super(["lrange", ...cmd], opts);
    }
}
